<template>
  <div class="fill-in">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>
